import { apiRoutes } from 'config/apiRoutes'
import { OpeningHoursRes } from 'features/openingHours/types/openingHours.types'
import { useContext } from 'react'
import { useQuery } from 'libs/query'
import { useAxiosPrivate } from 'shared/hooks'
import { AuthContext } from 'store'
import { queryKeys } from 'config/queryKeys'
import { getCurrentQuery } from 'utils/getCurrentQuery'

export const useFetchOpeningHours = () => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)
	const query = getCurrentQuery()

	const {
		data: openingHours,
		isPending: isLoadingOpeningHours,
		isSuccess: isOpeningHoursSuccess
	} = useQuery<OpeningHoursRes>({
		queryKey: queryKeys.openingHours.list(query),
		queryFn: () => axiosPrivate.get(apiRoutes.openingHours),
		enabled: !!auth.accessToken
	})

	return {
		openingHours,
		isLoadingOpeningHours,
		isOpeningHoursSuccess
	}
}
